// Umdah Crafts — Collapsible Categories
function initCollapsibleNav() {
  document.querySelectorAll('.menu-drawer__list-item--flat').forEach(function (li) {
    var submenu = li.querySelector('.menu-drawer__menu--childlist');
    if (!submenu) return;

    if (li.dataset.navInit) return;
    li.dataset.navInit = 'true';

    submenu.style.display = 'none';
    li.classList.remove('is-open');

    var trigger = li.querySelector('.menu-drawer__menu-item--mainlist');
    if (!trigger) return;

    // Use touchstart + mousedown to fire before Vessel intercepts
    ['mousedown', 'touchstart'].forEach(function (eventType) {
      trigger.addEventListener(eventType, function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var isOpen = li.classList.contains('is-open');

        document.querySelectorAll('.menu-drawer__list-item--flat[data-nav-init]').forEach(function (el) {
          el.classList.remove('is-open');
          var sub = el.querySelector('.menu-drawer__menu--childlist');
          if (sub) sub.style.display = 'none';
        });

        if (!isOpen) {
          li.classList.add('is-open');
          submenu.style.display = 'block';
        }
      }, { passive: false, capture: true });
    });
  });
}

document.addEventListener('DOMContentLoaded', initCollapsibleNav);

document.addEventListener('click', function (e) {
  if (e.target.closest('button[aria-expanded]') || e.target.closest('.header__icon--menu')) {
    setTimeout(initCollapsibleNav, 500);
  }
});


